import { render, staticRenderFns } from "./vSegRenovacion.vue?vue&type=template&id=c6728cf4&scoped=true&"
import script from "./vSegRenovacion.vue?vue&type=script&lang=js&"
export * from "./vSegRenovacion.vue?vue&type=script&lang=js&"
import style0 from "./vSegRenovacion.vue?vue&type=style&index=0&id=c6728cf4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6728cf4",
  null
  
)

export default component.exports